// react library imports
import { motion } from 'framer-motion';

// style imports and import from utils
import { headingAnimation, useAnimationHook } from 'Utils/animation';
import './Philosophy.css';

const Philosophy = ({title, description, reverse, logo}) => {
  const {ref, mainControls}=useAnimationHook(1)
  return (
    <motion.div className={`philosophy_container ${reverse && 'reverse_card'}`}
    ref={ref} initial="hidden" animate={mainControls}>
        <motion.div className='philosophy_profile_container'
        variants={headingAnimation}>
          <img src={logo} alt="logo" loading='lazy' />
        </motion.div>
        <div className='mues_black mues_row_gap_4
        philosophy_info_container'>
            <motion.h5 className='mues_font_weight_600'
            variants={headingAnimation}>{title}</motion.h5>
            <motion.h6 className='mues_font_weight_500
            mues_grey_I' variants={headingAnimation}>{description}</motion.h6>
        </div>
    </motion.div>
  )
}

export default Philosophy